import clsx from 'clsx'
import React, { FC } from 'react'

import { FacetDescriptionModal } from '@Components/Facet/FacetDescription/FacetDescriptionModal'
import { useNativeModal } from '@Components/Modal/NativeModal/NativeModal'

import styles from './FacetDescriptionButton.module.scss'

export interface FacetDescriptionButtonProps {
  children?: React.ReactNode
  className?: string
  facetDescriptionIDs: string[]
}

export const FacetDescriptionButton: FC<FacetDescriptionButtonProps> = ({
  children,
  className,
  facetDescriptionIDs,
}) => {
  const { open } = useNativeModal()
  return (
    <button
      className={clsx(className, styles.facetDescriptionButton)}
      onClick={() => {
        open(<FacetDescriptionModal
          facetDescriptionIDs={facetDescriptionIDs}
        />)
      }}
      type="button"
    >
      {children}
    </button>
  )
}
